import { createColumnHelper } from '@tanstack/react-table';

import { ResourceRow } from '../types';

export const columnHelper = createColumnHelper<ResourceRow>();
